import { createAction } from "@reduxjs/toolkit";
import { ActiveFilters, FilterField } from "types/filters";

export const filtersActionTypes = {
  updateFiltersFields: "filters/updateFiltersFields",
  updateActiveFilters: "filters/updateActiveFilters",
  getProjectFiltersFields: "filters/getProjectFiltersFields",
  setIsLoadingFilters: "filters/setIsLoadingFilters",
  resetActiveFilters: "filters/resetActiveFilters",
  saveActiveFilters: "filters/saveActiveFilters",
  filterLoadingCompleted: "filters/filterLoadingCompleted",
};

export const filtersActions = {
  updateFiltersFields: createAction(
    filtersActionTypes.updateFiltersFields,
    (filtersFields: FilterField) => ({ payload: filtersFields }),
  ),
  updateActiveFilters: createAction(
    filtersActionTypes.updateActiveFilters,
    (activeFilters: ActiveFilters) => ({ payload: activeFilters }),
  ),
  resetActiveFilters: createAction(filtersActionTypes.resetActiveFilters),
  saveActiveFilters: createAction(
    filtersActionTypes.saveActiveFilters,
    (activeFilters: ActiveFilters) => ({ payload: activeFilters }),
  ),
  getProjectFiltersFields: createAction(
    filtersActionTypes.getProjectFiltersFields,
  ),
  setIsLoadingFilters: createAction(
    filtersActionTypes.setIsLoadingFilters,
    (isLoadingFilters: boolean) => ({ payload: isLoadingFilters }),
  ),
  filterLoadingCompleted: createAction(
    filtersActionTypes.filterLoadingCompleted,
  ),
};
